module.exports = __webpack_public_path__ + "img/tit5.2b893ef9.png";